export const DADATA_BASE_ENDPOINT = 'https://qlean.ru/dadata/suggestions/api/4_1/rs/suggest';
// export const DADATA_TOKEN = '1a3b0db7bee65d261d6b29ac9f5907446bf788d5';

export enum FIELD_MODES {
  MANUAL = 'manual',
  DADATA = 'dadata',
}
